import React from 'react'
import cn from 'classnames'
import styles from './stream-options.module.scss'

export default function StreamNotificationOptions({ notifyPeriod, onChange, disabled = false }) {
    return (
        <div className={styles.optionsContainer}>
            <div className={styles.optionsComp}>
                <div className={styles.optionLabel}>Choose notification frequency:</div>

                <div className={styles.optionsContent}>
                    <div
                        className={cn(
                            styles.option,
                            notifyPeriod === 'instant_app' && styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange('instant_app')}
                    >
                        <span>
                            <i className="fa fa-bell-o"></i>
                        </span>{' '}
                        Instant
                    </div>

                    <div
                        className={cn(
                            styles.option,
                            (notifyPeriod === 'one_day_email' || notifyPeriod === null) &&
                                styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange('one_day_email')}
                    >
                        <span>
                            <i className="fa fa-envelope-o"></i>
                        </span>{' '}
                        Daily
                    </div>

                    <div
                        className={cn(
                            styles.option,
                            notifyPeriod === 'three_day_email' && styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange('three_day_email')}
                    >
                        <span>
                            <i className="fa fa-envelope-o"></i>
                        </span>{' '}
                        Every 3 days
                    </div>

                    <div
                        className={cn(
                            styles.option,
                            notifyPeriod === 'one_week_email' && styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange('one_week_email')}
                    >
                        <span>
                            <i className="fa fa-envelope-o"></i>
                        </span>{' '}
                        Weekly
                    </div>
                </div>
            </div>
        </div>
    )
}
